import MuiRootWrapper from "./mui-root-wrapper"
import React from 'react'

export const wrapRootElement = ({element}) => {
  return <MuiRootWrapper
            element={element}></MuiRootWrapper>
}
